import { CustomSVG } from "../atoms/CustomSVG";

export const iconRender = (iconReq, iconFill, width, height, className) => {
  try {
    const components = require("@egovernments/digit-ui-svg-components");
    const DynamicIcon = components?.[iconReq];
    const svgIcon = CustomSVG?.[iconReq];

    if (DynamicIcon) {
      const svgElement = DynamicIcon({
        width: width,
        height: height,
        fill: iconFill,
        className: className,
      });
      return svgElement;
    } else if (svgIcon) {
      const svgElement = svgIcon({
        width: width,
        height: height,
        fill: iconFill,
        className: className,
      });
      return svgElement;
    } else {
      console.warn(`🔍 Icon not found: ${iconReq} - Please check if the icon exists in svg-components`);
      return null;
    }
  } catch (error) {
    console.warn(`🔍 Icon loading failed: ${iconReq} - ${error.message || 'Unknown error'}`);
    return null;
  }
};
